import { ApiType } from 'utils/types'

export const userDefaults: ApiType['UserResponse'] = {
  uuid: '69060000-0000-4000-8000-000000000002',
  deleted: false,
  has_family_code: false,
  mfa: false,
  password_generated: false,
  phone_confirmed: false,
  provider: [],
  roles: [],
  state: 'ACTIVE',
}
